import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { AssetFinanceUrl } from "../../../../config";
import Form from "./form";
import DynamicTableForJson from "../../../../data/DynamicTable/dynamicTableForJson";
import Joyride from "react-joyride";
import AssetTypeDocumentRequirementTable from "../AssetTypeDocumentRequirement";
import { executeAnyMutation } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import Swal from "sweetalert2";

const base_url = AssetFinanceUrl.uri;

// Define tour steps for the Rights page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Collateral Asset Type setup page, where you can manage Collateral Asset Types.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find specific Collateral Asset Types by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to add a new Collateral Asset Type.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  {
    target: ".dynamic-table-actions",
    content: "Select actions to be able to Edit each Collateral Asset Type from this dropdown.",
    placement: "left",
  },
];

const CollateralAssetTypeTable = () => {
  const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride
  const [selectedAssetTypeId, setSelectedAssetTypeId] = useState(null);

  const handleToggleActive = async (row, refetch) => {
    const isCurrentlyActive = !!row?.IsActive;
    const action = isCurrentlyActive ? "Deactivate" : "Activate";
    const confirm = await Swal.fire({
      title: `${action} Asset Type?`,
      text: `Are you sure you want to ${action.toLowerCase()} "${row.DisplayName}"?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!confirm.isConfirmed) return;

    const response = await executeAnyMutation(
      "updateAssetType",
      {
        id: row.Id,
        code: row.Code,
        displayName: row.DisplayName,
        companyId: row.CompanyId,
        isActive: !isCurrentlyActive,
      },
      "assetType",
      false,
      base_url
    );

    if (response?.results) {
      await Swal.fire("Done!", `Asset Type has been ${!isCurrentlyActive ? "activated" : "deactivated"}.`, "success");
      if (refetch) refetch();
    } else {
      await Swal.fire("Error!", "Could not update the Asset Type. Please try again.", "error");
    }
  };

  const actions = {
    entity: localStorage.getItem("SelectedTabLabel"),
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    toggleActive: {
      key: "TOGGLE_ACTIVE",
      button_name: (row) => (row?.IsActive ? "Deactivate" : "Activate"),
      Show_Button: true,
      permission: "EditPermission",
      onClick: (row, refetch) => handleToggleActive(row, refetch),
    },
    documentRequirement: {
      key: "DocumentRequirement",
      button_name: "Document Requirement Settings",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
    dataObject: {
      ignoreFields: ["CreatedAt", "CreatedBy", "UpdatedAt", "UpdatedBy", "MetadataSchema", "CompanyId"],
      objectName: "allAssetTypes",
      parameters: "",
    },
    isSubRight: true,
    showStatus: true,
    showMore: {
      search: false,
      min: 0,
      max: 0
    }
  };
  const handleAction = (actionType, AssetTypeId) => {
    if (actionType === "documentRequirement" || actionType === "DocumentRequirement") {
      localStorage.setItem("AssetTypeId", AssetTypeId);
      setSelectedAssetTypeId(AssetTypeId); // Set the selected asset type ID
    }
    if (actionType === "EDIT") {
      setSelectedAssetTypeId(AssetTypeId); // Set the selected asset type ID
    }
    // Handle other actions as needed
  };

  return (
    <Box m="20px">
      {/* Joyride Component */}
      <Joyride
        steps={rightsTourSteps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            primaryColor: "#1976d2",
            zIndex: 10000,
          },
        }}
      />
      {/* Top Bar */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>
      {selectedAssetTypeId ? (
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Button onClick={() => setSelectedAssetTypeId(null)} variant="contained">
            Back to Asset Types
          </Button>

          <AssetTypeDocumentRequirementTable Id={selectedAssetTypeId} />

        </Box>
      ) : (
        <DynamicTableForJson
          title="Collateral Asset Management"
          subtitle="Manage Asset Types"
          FormComponent={Form}
          actions={actions}
          onRowClick={(row) => handleAction(actions.documentRequirement.key, row.Id)} // Call handleAction with asset type ID
          setSelectedAssetTypeId={setSelectedAssetTypeId}
          base_url={base_url}
          tourSteps={rightsTourSteps} // Pass tour steps as prop

        />
      )}
    </Box>

  );
};

export default CollateralAssetTypeTable;
